import propertyFormReducer from "../../private/properties/components/property-form/store/propertyStore";
import { PropertyFilterSlice } from "./realestate-list/realestate-list.slice";
import { StatsSlice } from "./stats/stats.slice";

const storeSlicesRf = {
  reducer: {
    [PropertyFilterSlice.name]: PropertyFilterSlice.reducer,
    [StatsSlice.name]: StatsSlice.reducer,
    ...propertyFormReducer.reducer
  }
};

export default storeSlicesRf;
